const WIDTH = "220px";
export const WIDTH_INPUT_TEXT_CONTROL = {
    width: WIDTH,
    minWidth: WIDTH
};
export const WIDTH_SELECT_CONTROL = {
    container: "max-width",
    containerSelect: WIDTH
};